<div style="display: flex;">
  <h1>{{title$.getValue()['title']}}</h1>
  <span style="padding-left: 5px;" *ngIf="title$.getValue()['subtitle']">{{title$.getValue()['subtitle']}}</span>
</div>
